import { Header, SideDrawer } from '@/components';
import { CONSTANTS } from '@/constants';
import { useIsMounted } from '@/hooks';
import { getValidClassNames, isTokenExpired } from '@/utils';
import { getAccessTokenCookie } from '@netfront/common-library';
import { useAuthentication } from '@netfront/gelada-identity-library';
import { Button } from '@netfront/ui-library';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const PublicHeader = () => {
  const { asPath } = useRouter();
  const token = getAccessTokenCookie();
  const { isAuthenticated } = useAuthentication();
  const { isMounted } = useIsMounted();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsMobileMenuOpen(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Header logo={{ href: '/' }}>
      <nav className="none lg:flex flex-1 justify-center absolute left-1/2 -translate-x-50">
        <ul className="flex list-style-none">
          {CONSTANTS.MENU.PUBLIC.map(({ href, id, label, target }) => (
            <li key={`public-header-${id}`} className="m-0">
              <Link
                className={getValidClassNames({
                  'text-xl flex color-black weight-500 px-5 py-12 text-decoration-none': true,
                  'color-green-500': asPath.includes(id),
                })}
                href={String(href)}
                {...(target && {
                  target,
                })}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <div className="ml-auto none lg:flex">
        {isMounted &&
          (!isTokenExpired(token) ? (
            <div aria-label="Go to dashboard" className="flex items-center">
              <Button
                additionalClassNames="ml-4"
                linkButton={{ id: 'return', url: '/dashboard' }}
                text="Go to dashboard"
                variant="primary"
              />
            </div>
          ) : (
            <div aria-label="Login and registration" className="flex items-center">
              <Button additionalClassNames="mr-4" linkButton={{ id: 'register', url: '/register' }} text="Register" />
              <Button linkButton={{ id: 'login', url: '/login' }} text="Login" variant="secondary" />
            </div>
          ))}
      </div>

      <div className="flex lg:none ml-auto">

        {isAuthenticated ? (
          <Button
            additionalClassNames="ml-4"
            linkButton={{ id: 'return', url: '/dashboard' }}
            text="Go to dashboard"
            variant="primary"
          />
        ) : (
          <>
            <Button linkButton={{ id: 'register', url: '/register' }} text="Register" />

            <Button additionalClassNames='ml-4 none lg:inline-flex' linkButton={{ id: 'login', url: '/login' }} text="Login" variant="secondary" />
          </>
        )}
        

       
        <button
          className="c-header-mobile-trigger flex md:hidden items-center justify-center ml-auto bg-transparent border-none ml-4 pointer"
          onClick={() => setIsMobileMenuOpen(true)}
        >
          <span className="sr-only">Open menu</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-12 h-12"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
          </svg>
        </button>

        {isMobileMenuOpen && (
          <SideDrawer
            logo={{
              href: '/',
            }}
            onClose={() => setIsMobileMenuOpen(false)}
          >
            <nav aria-label="Mobile navigation" className="m-auto">
              <ul className="flex flex-col items-center list-style-none">
                {CONSTANTS.MENU.PUBLIC.map(({ href, label, id }) => (
                  <li key={`public-side-menu-${id}`}>
                    <Link
                      className="flex items-center color-black weight-600 px-6 py-4 text-decoration-none hover:color-primary"
                      href={String(href)}
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="mt-auto flex justify-center py-4">
              {isMounted &&
                (isAuthenticated ? (
                  <div aria-label="Go to dashboard" className="flex items-center">
                    <Button
                      additionalClassNames="ml-4"
                      linkButton={{ id: 'return', url: '/dashboard' }}
                      text="Go to dashboard"
                      variant="primary"
                    />
                  </div>
                ) : (
                  <div aria-label="Login and registration" className="flex flex-col items-center">
                    <Button
                      additionalClassNames="mb-6"
                      linkButton={{ id: 'register', url: '/register' }}
                      text="Register"
                      variant="primary"
                    />
                    <Button linkButton={{ id: 'login', url: '/login' }} text="Login" variant="secondary" />
                  </div>
                ))}
            </div>
          </SideDrawer>
        )}
      </div>
    </Header>
  );
};
